<template>
  <custom-overlay>
    <div class="h-full">
      <div style="padding-top: 10vh; padding-bottom: 40px">
        <div class="password-wrapper bg-white">
          <div class="text-center">
            <img src="~@/assets/img/lock.png" alt="" width="88" />
            <div class="mt-6" style="margin-bottom: 48px">
              <span>输入密码进行访问</span>
            </div>
          </div>
          <div class="relative gray-input-wrapper" :class="{ 'pb-10': tip }">
            <el-input v-model="password" placeholder="答题密码" />
            <el-input v-if="passwordType === 4" v-model="attrValue" class="mt-2" :placeholder="passwordPropertyHint" />
            <div class="absolute bottom-0 left-0 right-0">
              <span class="text-red leading-18">
                {{ tip }}
              </span>
            </div>
          </div>
          <div class="text-center mt-5">
            <el-button type="primary" @click="onStart" class="w-full">确定</el-button>
          </div>
        </div>
      </div>
    </div>
  </custom-overlay>
</template>

<script>
import CustomOverlay from '@/components/overlay/CustomOverlay'

export default {
  name: 'OverlayPassword',
  components: { CustomOverlay },
  data() {
    return {
      password: '',
      attrValue: '',
      tip: '',
      passwordType: 1
    }
  },
  computed: {
    passwordPropertyHint() {
      return this.$bus.survey.otherSetting?.passwordPropertyHint
    }
  },
  methods: {
    onStart() {
      if (!this.password) {
        this.tip = '密码不能为空'
        return
      }
      this.$bus.onStartAnswerByPWD(this.password, this.attrValue, () => {
        this.$emit('close')
      })
    },
    onUpdate(msg, type) {
      this.tip = msg
      if (type) {
        this.passwordType = type
      }
    }
  }
}
</script>

<style lang="scss">
.gray-input-wrapper {
  .el-input {
    .el-input__inner {
      @apply bg-theme-gray;
      text-align: center;
      border: none !important;
    }
  }
}
</style>
